export default __webpack_public_path__ + "static/media/checkbox.4e2450ab.svg";